module.exports = __webpack_public_path__ + "static/scale-model-of-hayward-california-6ffd1af7dd45ac99b73e16fb821ef4f3.png";